import React, { useContext } from 'react';
import { Button, Col } from 'react-bootstrap';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { navigate } from '@reach/router';

import strings from 'common/strings';
import { currencyFormatter } from 'utils/formatter';
import permissions from 'common/permissions';
import { usePermissions, useWindowSize } from 'hooks';
import { overviewBuilder } from 'navigation/routes';
import { getDaysInInventory } from 'utils/vehicle';
import { VehicleCardContext } from '../../VehicleCard';
type InventoryFinanceMetric = 'price' | 'cost' | 'profit';

var TabButtonsRow = (handleClickNav: (clickSource: string) => void) => {
  const windowSize = useWindowSize();

  if (windowSize.width < 1350) {
    return (
      <div className="VehicleCard-step-buttons-container d-flex full-width">
        <Col className="d-flex justify-content-center">
          <Button
            className="view-vehicle"
            variant="outline-primary"
            block
            onClick={() => handleClickNav('VehicleCard-step-buttons-container')}
          >
            {strings.VIEW_VEHICLE.toUpperCase()}
          </Button>
        </Col>
      </div>
    );
  }

  return (
    <Button
      as="button"
      className="see-more-button"
      variant="link"
      onClick={() => handleClickNav('VehicleCard-step-buttons-container')}
    >
      <span>View more</span>
      <ChevronRightIcon />
    </Button>
  );
};

var VehicleCardInventoryDetails = () => {
  const { vehicle, inExtensionCardMode, position } =
    useContext(VehicleCardContext);
  const { hasPermission } = usePermissions();
  const vehicleId = vehicle?.vehicleCard?.id ?? '';
  const daysInInventory = vehicle && getDaysInInventory(vehicle);
  const vehicleInventoryFinanceCurrency = (
    metric: InventoryFinanceMetric
  ): string => {
    const value = vehicle?.[metric]?.amount;
    if (!value) {
      return '';
    }
    const currency = vehicle?.[metric]?.currency || strings.DEFAULT_CURRENCY;
    return currency === 'USD' ? '' : currency;
  };

  const vehicleInventoryFinanceValue = (
    metric: InventoryFinanceMetric
  ): string => {
    if (!hasPermission(permissions.INVENTORY_VDP_RECON_INFO_VIEW))
      return strings.EMPTY_VALUE;
    const value = vehicle?.[metric]?.amount;
    return value ? currencyFormatter(value) : strings.EMPTY_VALUE;
  };

  const handleClickNavToRecon = (clickSource: string): Promise<void> | null => {
    if (vehicleId) {
      return navigate(`${overviewBuilder(vehicleId, true)}`);
    }
    return null;
  };

  return (
    <>
      <div className="VehicleCard-tabs-row d-flex mt-0 flex-wrap">
        <div
          className="VehicleCard-tabs-row-inventory-item"
          id={`vehicle-card-sales-price-${position}`}
        >
          <div className="VehicleCard-label">
            {strings.SALES_PRICE.toUpperCase()}
          </div>
          <div className="VehicleCard-value">
            <span>{vehicleInventoryFinanceValue('price')}</span>
            <small className="mr-1">
              {vehicleInventoryFinanceCurrency('price')}
            </small>
          </div>
        </div>
        <div
          className="VehicleCard-tabs-row-inventory-item"
          id={`vehicle-card-cost-${position}`}
        >
          <div className="VehicleCard-label">{strings.COST.toUpperCase()}</div>
          <div className="VehicleCard-value">
            <span>{vehicleInventoryFinanceValue('cost')}</span>
            <small className="mr-1">
              {vehicleInventoryFinanceCurrency('cost')}
            </small>
          </div>
        </div>
        <div
          className="VehicleCard-tabs-row-inventory-item"
          id={`vehicle-card-profit-${position}`}
        >
          <div className="VehicleCard-label">
            {strings.PROFIT.toUpperCase()}
          </div>
          <div className="VehicleCard-value">
            <span className="font-weight-600">
              {vehicleInventoryFinanceValue('profit')}
            </span>
            <small className="mr-1">
              {vehicleInventoryFinanceCurrency('profit')}
            </small>
          </div>
        </div>
        <div className="VehicleCard-tabs-row-inventory-item">
          <div className="VehicleCard-label">
            {strings.DAYS_IN_INVENTORY.toUpperCase()}
          </div>
          <div
            className="VehicleCard-value font-weight-600"
            id={`vehicle-card-inventory-days-${position}`}
          >
            {daysInInventory ? daysInInventory : strings.EMPTY_VALUE}
          </div>
        </div>
      </div>
      {!inExtensionCardMode && (
        <div className="tab-buttons-row">
          {TabButtonsRow(handleClickNavToRecon)}
        </div>
      )}
    </>
  );
};

export default VehicleCardInventoryDetails;
